import { render, staticRenderFns } from "./essayQuestion.vue?vue&type=template&id=1bbedfba&"
import script from "./essayQuestion.vue?vue&type=script&lang=js&"
export * from "./essayQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports